<template>
  <div class="auth-container">
    <div class="background-container">
      <div class="top-brasao" :style="{ backgroundColor: colorTop }">
        <img :src="brasaoSrc" alt="Logo" class="top-logo" />
      </div>
      <div class="background-content">
        <h1>Bem-vindo ao<br> sistema de Avaliação
        </h1>
        <p>O sistema de Avaliação e Aquisição de Estabilidade garante a transparência e eficiência no acompanhamento do desempenho dos servidores públicos da Prefeitura de {{ clientName }}.</p>
        <div class="manuals-container">
          <h2>Manuais dos perfis de usuários</h2>
          <div class="manuals-columns">
            <ul class="manuals-list">
              <li v-for="manual in firstHalfManuals" :key="manual.name">
                <a :href="manual.url" target="_blank" class="manual-item">
                  {{ manual.name }}
                </a>
              </li>
            </ul>
            <ul class="manuals-list">
              <li v-for="manual in secondHalfManuals" :key="manual.name">
                <a :href="manual.url" target="_blank" class="manual-item">
                  {{ manual.name }}
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="form-container">
      <AppLogo class="h-48" />
        <slot />
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'Auth',
  data() {
    return {
      manuals: [],
      options: {
        pmc: { 
          color: '#f5e143',
          brasao: '/assets/brasao-pmc.png',
          clientName: 'Cuiabá'
        },
        pmvg: { 
          color: '#081d57',
          brasao: '/assets/brasao-pmvg.png',
          clientName: 'Várzea Grande'
        },
        error: { 
          color: '#ffffff',
          brasao: '/assets/logo.png',// se o sistema não pegar config de cliente, usar logo padrão do sistema
          clientName: 'Undefined'
        }
      },
    };
  },

  methods: {
    ...mapActions(['getTenant']),
  },
  
  computed: {
    ...mapGetters(['getCurrentTenant']),
    currentTenant(){
      return this.getCurrentTenant
    },

    brasaoSrc() {
      return this.options[this.getCurrentTenant || 'error'].brasao
    },

    clientName() {
      return this.options[this.getCurrentTenant || 'error'].clientName
    },

    colorTop() {
      return this.options[this.getCurrentTenant || 'error'].color
    },

    firstHalfManuals() {
      const half = Math.ceil(this.manuals.length / 2);
      return this.manuals.slice(0, half);
    },
    secondHalfManuals() {
      const half = Math.ceil(this.manuals.length / 2);
      return this.manuals.slice(half);
    }
  },

  mounted() {
    this.getTenant()
    axios.get('/manual').then((response) => {
      this.manuals = response.data.map(e => ({
        url: `/manual/download/${e.id}`,
        name: e.nome
      }));
    });
  },
};
</script>

<style scoped>
.auth-container {
  display: flex;
  height: 100vh;
}

.background-container {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  width: 100%;
  height: 100%;
  background-image: url('/assets/loginBackground.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  color: white;
}

.background-content h1 {
  font-size: 2rem;
  font-weight: bold;
  text-align: left;
  width: 100%;
  line-height: 1.3;
  margin-bottom: 1rem;
  padding-left: 1rem;
}

.background-content p {
  font-size: 0.8rem;
  line-height: 1.4;
  text-align: left;
  padding-left: 1rem;
  width: 100%;
  max-width: 80%;
  margin-top: 1rem;
}

/* Seção de Manuais */
.manuals-container {
  margin-top: 2rem;
  padding: 1rem;
  width: 100%;
  background-color: #2b9560; /* Cor de fundo */
  border-radius: 8px;
}

.manuals-container h2 {
  font-size: 1.5rem;
  font-weight: bold;
  margin-bottom: 1rem;
}

.manuals-columns {
  display: flex;
  justify-content: space-between;
}

.manuals-list {
  list-style-type: none;
  padding: 0;
  width: 48%;
}

.manuals-list .manual-item {
  font-size: 1rem;
  color: #ffffff;
  text-decoration: none;
  display: block;
  margin-bottom: 0.5rem;
}

.manuals-list .manual-item:hover {
  text-decoration: underline;
}

.top-brasao {
  width: 100%;
  height: 20%;
  background-color: var(--bg-brasao, white);
  display: flex;
  align-items: center;
  justify-content: center;
}

.top-logo {
  max-width: 150px;
  height: auto;
  object-fit: contain;
}

.background-content {
  padding: 2rem;
  z-index: 1;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
}

.form-container {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 2rem;
}
</style>